<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.group.accountEntry.title.list")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.group.accountEntry.error." />
      </v-col>
    </v-row>

    <template v-if="view.list.length > 0">

    <v-row justify="center">
      <v-col cols="12">
        <div>{{$t("message.group.accountEntry.desc.list.text1")}}</div>
        <div>{{$t("message.group.accountEntry.desc.list.text2")}}</div>
        <div>{{$t("message.group.accountEntry.desc.list.text3")}}</div>
      </v-col>
    </v-row>

    <v-row justify="start">
      <v-col cols="12" md="4" class="py-1">
          <mp-button red min wide @click="beforeApproval">{{$t("message.group.accountEntry.desc.list.approval")}}</mp-button>
          <mp-dialog approvalList confirm :show="dialog.approvalConfirm" @clickOk="goApproval" @clickCancel="dialog.approvalConfirm = false"/>
          <mp-dialog approvalList :show="dialog.approvalComplete" @clickOk="afterApproval" />
      </v-col>
      <v-col cols="12" md="4" class="py-1">
          <mp-button red min wide @click="beforeReject">{{$t("message.group.accountEntry.desc.list.reject")}}</mp-button>
          <mp-dialog rejectList confirm :show="dialog.rejectConfirm" @clickOk="goReject" @clickCancel="dialog.rejectConfirm = false"/>
          <mp-dialog rejectList :show="dialog.rejectComplete" @clickOk="afterReject" />
          <mp-dialog requireSelect :show="dialog.requireSelect" @clickOk="dialog.requireSelect = false" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-2 py-0 pt-md-0">
          <div class="text-right ma-0 py-0 list-count">{{$t("message.group.accountEntry.desc.list.listCount1")}}：{{ view.list.length | addComma  }}{{$t("message.group.accountEntry.desc.list.listCount2")}}</div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          v-model="form.selected"
          show-select
          item-key="accountEntryId"
          :single-select="false"
          :headers="headers"
          :items="this.view.list"
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          hide-default-footer
          mobile-breakpoint=0
          class="elevation-1"
          :page.sync="search.paging.page"
          :items-per-page="search.paging.itemsPerPage"
          @page-count="search.paging.pageCount = $event"
        >
          <template v-slot:[`item.entryDt`]="{ item }">
            {{ item.entryDt | dateFormatter }}
          </template>
          <template v-slot:[`item.name`]="{ item }">
              <router-link :to="'/group/account/entry/detail/' + item.accountEntryId">
              {{ item.name }}
            </router-link>
          </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination color="#0F9956" circle v-model="search.paging.page" :length="search.paging.pageCount"></v-pagination>
          </div>
        </v-col>
      </v-row>

          </template>
    <template v-else-if="view.list.length === 0">

      <v-row justify="center">
        <v-col cols="12" class="pt-0">
          <div>
            {{$t("message.group.accountEntry.desc.list.noData")}}
          </div>
      </v-col>
    </v-row>
    </template>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'

import { GroupAccountEntry } from '@/api'
import MpError from '@/components/item/MpError'

export default {
  name: 'top',
  components: {
    MpError,
    MpButton,
    MpDialog
  },
  data: () => ({
    view: {
      errors: [],
      list: []
    },
    form: {
      selected: []
    },
    search: {
      paging: {
        page: 1,
        pageCount: 5,
        itemsPerPage: 50
      }
    },
    dialog: {
      rejectConfirm: false,
      rejectComplete: false,
      approvalConfirm: false,
      approvalComplete: false,
      requireSelect: false
    }
  }),
  computed: {
    headers () {
      return [
        { text: i18n.t('message.group.accountEntry.label.list.entryDt'), value: 'entryDt', sortable: false, width: 150 },
        { text: i18n.t('message.group.accountEntry.label.list.mailAddress'), value: 'mailAddress', sortable: false },
        { text: i18n.t('message.group.accountEntry.label.list.name'), value: 'name', sortable: false, width: 200 },
        { text: i18n.t('message.group.accountEntry.label.list.busho'), value: 'busho', sortable: false, width: 150 },
        { text: i18n.t('message.group.accountEntry.label.list.telNo'), value: 'telNo', sortable: false, width: 150 }
      ]
    }
  },
  methods: {
    async goSearch () {
      // サーバから取得
      this.form.selected = []
      this.view.list = await GroupAccountEntry.search()
    },
    beforeApproval () {
      if (this.form.selected.length > 0) {
        // 確認ダイアログを表示
        this.dialog.approvalConfirm = true
      } else {
        // 未選択エラーダイアログを表示
        this.dialog.requireSelect = true
      }
    },
    beforeReject () {
      if (this.form.selected.length > 0) {
        // 確認ダイアログを表示
        this.dialog.rejectConfirm = true
      } else {
        // 未選択エラーダイアログを表示
        this.dialog.requireSelect = true
      }
    },
    async goApproval () {
      this.view.errors = []
      // ダイアログ非表示
      this.dialog.approvalConfirm = false

      await GroupAccountEntry.approve({
        accountEntryIdList: this.form.selected.map(accountEntry => accountEntry.accountEntryId)
      })
        .then(() => { this.dialog.approvalComplete = true })
        .catch(error => {
          this.view.errors = error.messages
        })
    },
    async goReject () {
      this.view.errors = []
      // ダイアログ非表示
      this.dialog.rejectConfirm = false

      await GroupAccountEntry.reject({ accountEntryIdList: this.form.selected.map(accountEntry => accountEntry.accountEntryId) })
        .then(() => { this.dialog.rejectComplete = true })
        .catch(error => {
          this.view.errors = error.messages
        })
    },
    afterApproval () {
      // ダイアログを閉じる
      this.dialog.approvalComplete = false

      this.goSearch()
    },
    afterReject () {
      // ダイアログを閉じる
      this.dialog.rejectComplete = false

      // 再表示のためサーバから最新の一覧を取得
      this.goSearch()
    }
  },

  created: function () {
    this.goSearch()
  }
}
</script>

<style scoped>
  .v-data-table td {
    width: 50px;
  }
</style>
